"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHILD_AND_TEEN_INSIDE_CANADA_VISITOR_INTAKE = exports.CHILD_ADULT_INSIDE_CANADA_VISITOR_INTAKE = exports.PARTNER_INSIDE_CANADA_VISITOR_INTAKE = exports.APPLICANT_INSIDE_CANADA_VISITOR_INTAKE = exports.VISITOR_PARTNER_INTAKE = exports.VISITOR_CHILD_ADULT_INTAKE = exports.VISITOR_CHILD_AND_CHILD_TEEN_INTAKE = exports.VISITOR_APPLICANT_INTAKE = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const question_groups_1 = require("../../groups/question-groups");
const form_1 = require("../../utils/form");
const defaults_1 = require("../defaults");
const defaults_2 = require("../defaults");
const defaults_3 = require("../defaults");
exports.VISITOR_APPLICANT_INTAKE = (0, form_1.form)({
    name: "VISITOR_APPLICANT_INTAKE",
    title: "Intake form",
    content: [
        question_groups_1.QuestionGroup["DETAILS_VISIT"],
        question_groups_1.QuestionGroup["APPLICANT_VISITOR_PERSONAL_DETAILS"],
        question_groups_1.QuestionGroup["APPLICANT_STUDY_CONTACT_INFORMATION"],
        question_groups_1.QuestionGroup["APPLICANT_STUDY_PRIMARY_ADDRESS"],
        question_groups_1.QuestionGroup["APPLICANT_STUDY_CURRENT_COUNTRY_RESIDENCE"],
        question_groups_1.QuestionGroup["TALENT_PREVIOUS_COUNTRY_RESIDENCE"],
        question_groups_1.QuestionGroup["TALENT_MARITAL_STATUS"],
        question_groups_1.QuestionGroup["TALENT_EMPLOYMENT"],
        question_groups_1.QuestionGroup["TALENT_EDUCATION"],
        question_groups_1.QuestionGroup["TALENT_US_PR"],
        question_groups_1.QuestionGroup["TALENT_NATIONAL_IDENTITY"],
        question_groups_1.QuestionGroup["TALENT_PASSPORT"],
        question_groups_1.QuestionGroup["TALENT_LANGUAGES"],
        question_groups_1.QuestionGroup["APPLICANT_BACKGROUND_INFORMATION"],
        question_groups_1.QuestionGroup["TALENT_FAMILY_INFORMATION_APPLICANT"],
    ],
    id: 41,
});
exports.VISITOR_CHILD_AND_CHILD_TEEN_INTAKE = (0, form_1.form)({
    name: "VISITOR_CHILD_AND_CHILD_TEEN_INTAKE",
    title: "Intake form",
    content: [
        question_groups_1.QuestionGroup["DETAILS_VISIT"],
        question_groups_1.QuestionGroup["TALENT_PERSONAL_DETAILS"],
        question_groups_1.QuestionGroup["TALENT_CHILD_AND_TEEN_CONTACT_INFORMATION"],
        question_groups_1.QuestionGroup["TALENT_CURRENT_COUNTRY_RESIDENCE"],
        question_groups_1.QuestionGroup["TALENT_PREVIOUS_COUNTRY_RESIDENCE"],
        question_groups_1.QuestionGroup["TALENT_LANGUAGES"],
        question_groups_1.QuestionGroup["TALENT_PASSPORT"],
        question_groups_1.QuestionGroup["TALENT_NATIONAL_IDENTITY"],
        question_groups_1.QuestionGroup["TALENT_US_PR"],
        question_groups_1.QuestionGroup["APPLICANT_BACKGROUND_INFORMATION"],
    ],
    id: 42,
});
exports.VISITOR_CHILD_ADULT_INTAKE = (0, form_1.form)({
    name: "VISITOR_CHILD_ADULT_INTAKE",
    title: "Intake form",
    content: [
        question_groups_1.QuestionGroup["DETAILS_VISIT"],
        question_groups_1.QuestionGroup["TALENT_PERSONAL_DETAILS"],
        question_groups_1.QuestionGroup["TALENT_OTHER_CONTACT_INFORMATION"],
        question_groups_1.QuestionGroup["TALENT_CURRENT_COUNTRY_RESIDENCE"],
        question_groups_1.QuestionGroup["TALENT_PREVIOUS_COUNTRY_RESIDENCE"],
        question_groups_1.QuestionGroup["TALENT_MARITAL_STATUS"],
        question_groups_1.QuestionGroup["TALENT_LANGUAGES"],
        question_groups_1.QuestionGroup["TALENT_EDUCATION"],
        question_groups_1.QuestionGroup["TALENT_EMPLOYMENT"],
        question_groups_1.QuestionGroup["TALENT_PASSPORT"],
        question_groups_1.QuestionGroup["TALENT_NATIONAL_IDENTITY"],
        question_groups_1.QuestionGroup["TALENT_US_PR"],
        question_groups_1.QuestionGroup["APPLICANT_BACKGROUND_INFORMATION"],
        question_groups_1.QuestionGroup["TALENT_FAMILY_INFORMATION_CHILD_ADULT"],
    ],
    id: 43,
});
exports.VISITOR_PARTNER_INTAKE = (0, form_1.form)({
    name: "VISITOR_PARTNER_INTAKE",
    title: "Intake form",
    content: [
        question_groups_1.QuestionGroup["DETAILS_VISIT"],
        question_groups_1.QuestionGroup["TALENT_PERSONAL_DETAILS"],
        question_groups_1.QuestionGroup["TALENT_OTHER_CONTACT_INFORMATION"],
        question_groups_1.QuestionGroup["TALENT_CURRENT_COUNTRY_RESIDENCE"],
        question_groups_1.QuestionGroup["TALENT_PREVIOUS_COUNTRY_RESIDENCE"],
        question_groups_1.QuestionGroup["TALENT_MARITAL_STATUS"],
        question_groups_1.QuestionGroup["TALENT_LANGUAGES"],
        question_groups_1.QuestionGroup["TALENT_EDUCATION"],
        question_groups_1.QuestionGroup["TALENT_EMPLOYMENT"],
        question_groups_1.QuestionGroup["TALENT_PASSPORT"],
        question_groups_1.QuestionGroup["TALENT_NATIONAL_IDENTITY"],
        question_groups_1.QuestionGroup["TALENT_US_PR"],
        question_groups_1.QuestionGroup["APPLICANT_BACKGROUND_INFORMATION"],
        question_groups_1.QuestionGroup["TALENT_FAMILY_INFORMATION_PARTNER"],
    ],
    id: 44,
});
/***********************
 * INSIDE CANADA FORMS *
 ***********************/
exports.APPLICANT_INSIDE_CANADA_VISITOR_INTAKE = (0, form_1.form)({
    name: "APPLICANT_INSIDE_CANADA_VISITOR_INTAKE",
    title: "Intake form for inside Canada Visitor Visa",
    content: [
        question_groups_1.QuestionGroup["COMING_INTO_CANADA"],
        question_groups_1.QuestionGroup["DETAILS_VISIT_INSIDE_CANADA_NO_PURPOSE"],
        ...defaults_3.APPLICANT_DEFAULT_QUESTION_GROUPS.filter((questionGroup) => !defaults_3.ALL_FAMILY_INFO_GROUPS.includes(questionGroup.uniqueKey)),
    ],
    id: 64,
});
exports.PARTNER_INSIDE_CANADA_VISITOR_INTAKE = (0, form_1.form)({
    name: "PARTNER_INSIDE_CANADA_VISITOR_INTAKE",
    title: "Intake form for inside Canada Visitor Visa",
    content: [
        question_groups_1.QuestionGroup["COMING_INTO_CANADA"],
        question_groups_1.QuestionGroup["DETAILS_VISIT_INSIDE_CANADA_NO_PURPOSE"],
        ...defaults_2.PARTNER_DEFAULT_QUESTION_GROUPS.filter((questionGroup) => !defaults_3.ALL_FAMILY_INFO_GROUPS.includes(questionGroup.uniqueKey)),
    ],
    id: 65,
});
exports.CHILD_ADULT_INSIDE_CANADA_VISITOR_INTAKE = (0, form_1.form)({
    name: "CHILD_ADULT_INSIDE_CANADA_VISITOR_INTAKE",
    title: "Intake form for inside Canada Visitor Visa",
    content: [
        question_groups_1.QuestionGroup["COMING_INTO_CANADA"],
        question_groups_1.QuestionGroup["DETAILS_VISIT_INSIDE_CANADA_NO_PURPOSE"],
        ...defaults_1.CHILD_ADULT_DEFAULT_QUESTION_GROUPS.filter((questionGroup) => !defaults_3.ALL_FAMILY_INFO_GROUPS.includes(questionGroup.uniqueKey)),
    ],
    id: 66,
});
exports.CHILD_AND_TEEN_INSIDE_CANADA_VISITOR_INTAKE = (0, form_1.form)({
    name: "CHILD_AND_TEEN_INSIDE_CANADA_VISITOR_INTAKE",
    title: "Intake form for inside Canada Visitor Visa",
    content: [
        question_groups_1.QuestionGroup["COMING_INTO_CANADA"],
        question_groups_1.QuestionGroup["DETAILS_VISIT_INSIDE_CANADA_NO_PURPOSE"],
        ...defaults_1.CHILD_AND_CHILD_TEEN_DEFAULT_QUESTION_GROUPS.filter((questionGroup) => !defaults_3.ALL_FAMILY_INFO_GROUPS.includes(questionGroup.uniqueKey)),
    ],
    id: 67,
});
